import React, { Component, createRef } from 'react'

import NewLayout from '../layout/newLayout'
import SEO from '../components/seo'
import PageContents from '../components/pageContents'
import { sendContact } from "../services/contact"
import { signUp } from "../services/email"

import SampleRequestFormNew from '../components/sampleRequestFormNew'

import styles from '../styles/scss/templates/industrialSampleRequestForm.module.scss'

class SampleRequestFormNewPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
      submitting: false,
      error: null,
      isStaging: false
    }
  }

  thankYouRef = createRef()

  // The thank-you replaces the form; move focus (and so the scroll position,
  // which otherwise stays down by the submit button) to it
  componentDidUpdate(prevProps, prevState) {
    if (this.state.submitted && !prevState.submitted && this.thankYouRef.current) {
      this.thankYouRef.current.focus()
    }
  }

  componentDidMount() {
    // Check if we're in a staging environment using Gatsby environment variable
    const isStaging = process.env.GATSBY_DATOCMS_ENV === 'staging' || 
                     process.env.GATSBY_DATOCMS_ENV === 'development';
    this.setState({ isStaging });
    console.log('Environment:', process.env.GATSBY_DATOCMS_ENV);
    console.log('Is staging:', isStaging);
  }

  onSubmit = (formData) => {
    // Guard against a second click while the first request is in flight
    if (this.state.submitting) return;
    this.setState({ submitting: true, error: null });
    
    // Use sendContact service with proper CORS handling
    sendContact(formData, 'sample-request-new').then(() => {
      // The sampling DE only records the newsletter consent as BrandOptIn, so
      // also run it through the subscribe lambda to add the person to the
      // master subscriber list, as /signup/ and contact-us do. Fire-and-forget:
      // the sample request already succeeded and must not be resubmitted.
      // confirmation: true keeps subscribe from writing EmailOptIn=false on an
      // existing subscriber; no phone, so no second SMS enrollment.
      if (formData.consent_newsletter) {
        signUp({
          firstName: formData.first_name,
          lastName: formData.last_name,
          email: formData.email,
          occupation__pc: formData.field_of_work,
          confirmation: true,
          formIdentifier: 'signup'
        }).catch((err) => {
          console.error('Newsletter signup failed:', err && err.message)
        })
      }
      this.setState({
        submitting: false,
        submitted: true,
        error: null
      });
    }).catch((err) => {
      console.error('Error submitting form:', err);
      this.setState({ 
        submitting: false,
        submitted: false,
        error: true
      });
    });
  }

  render() {
    const pg = this.props.pageContext.page
    // Prefer the sample-request-specific thank-you; fall back to the shared
    // contact one (also attached to Contact Us, industrial forms, etc.)
    const thankyou =
      pg.attachments.find(att => att.slug === 'thank-you-sample-request') ||
      pg.attachments.find(att => att.slug === 'thank-you-contact')
    if (!thankyou) {
      throw new Error("thank-you-sample-request or thank-you-contact is not attached")
    }
    
    // Check if sampleRequestForm exists in pageContext and provide defaults if not
    const sampleRequestForm = this.props.pageContext.sampleRequestForm || {}
    
    // Format data for Select component - needs { value, text } format
    const fieldsOfWork = (sampleRequestForm.fieldsOfWork || []).map(field => ({
      value: field.value,
      text: field.title
    }))
    
    const sources = (sampleRequestForm.sources || []).map(source => ({
      value: source.value,
      text: source.name
    }))

    return (
      <NewLayout>
        {pg.seo.title && <h1 style={{ display: 'none' }}>{pg.seo.title}</h1>}
        <SEO page={pg} />
        <div className='d-flex flex-column flex-fill'>
          <div className={styles.pageWrapper}>
            <div className={styles.container}>
              {
                this.state.submitted ?
                <div className={styles.thankYou} tabIndex={-1} ref={this.thankYouRef}>
                  <PageContents content={thankyou.content} />
                </div>
                :
                <>
                  {
                  //STAGING FLAG
                  this.state.isStaging && (
                    <div style={{
                      backgroundColor: '#ff9800',
                      color: 'white',
                      padding: '10px',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      marginBottom: '20px',
                      borderRadius: '4px'
                    }}>
                      STAGING ENVIRONMENT
                    </div>
                  )
                    //STAGING FLAG ENDS
                  }
                  <SampleRequestFormNew 
                    onSubmit={this.onSubmit}
                    fieldsOfWork={fieldsOfWork}
                    sources={sources}
                    submitting={this.state.submitting}
                    submitError={!!this.state.error}
                  />
                </>
              }
            </div>
          </div>
        </div>
      </NewLayout>
    )
  }
}

export default SampleRequestFormNewPage
